import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/common/Header';
import Footer from '../components/common/Footer';

// 프로필 타입 정의
interface Profile {
  id: number;
  name: string;
  age: number;
  location: string;
  occupation: string;
  education: string;
  height: number;
  interests: string[];
  description: string;
  imageUrl: string;
}

function MatchPage() {
  // 필터 상태
  const [ageRange, setAgeRange] = useState({ min: 20, max: 35 });
  const [locationFilter, setLocationFilter] = useState('all');
  
  // 페이지네이션 상태
  const [currentPage, setCurrentPage] = useState(1);
  const profilesPerPage = 6;
  
  // 더미 프로필 데이터 - Unsplash 이미지 적용 (18명으로 확장)
  const profiles: Profile[] = [
    {
      id: 1,
      name: '응웬 티 흐엉',
      age: 26,
      location: '호치민',
      occupation: '간호사',
      education: '대학교 졸업',
      height: 162,
      interests: ['요리', '여행', '독서'],
      description: '안녕하세요. 저는 호치민에서 간호사로 일하고 있는 흐엉입니다. 한국 문화와 음식을 좋아하며, 성실하고 따뜻한 사람입니다. 한국어를 공부하고 있으며 한국에서의 새로운 삶을 꿈꾸고 있습니다.',
      imageUrl: 'https://images.unsplash.com/photo-1591448764624-d7973a442bff?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=928&q=80',
    },
    {
      id: 2,
      name: '팜 티 린',
      age: 24,
      location: '하노이',
      occupation: '교사',
      education: '대학교 졸업',
      height: 158,
      interests: ['음악', '아이들과 놀기', '영화 감상'],
      description: '하노이에서 초등학교 교사로 일하고 있습니다. 아이들을 좋아하고 가족을 소중히 여깁니다. 한국 드라마를 즐겨보며 한국 문화에 관심이 많습니다. 서로 존중하는 행복한 가정을 꾸리고 싶습니다.',
      imageUrl: 'https://images.unsplash.com/photo-1519985176271-adb1088fa94c?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=928&q=80',
    },
    {
      id: 3,
      name: '트란 티 타오',
      age: 28,
      location: '다낭',
      occupation: '회계사',
      education: '대학원 졸업',
      height: 165,
      interests: ['하이킹', '수영', '요가'],
      description: '다낭에서 회계사로 일하고 있습니다. 활동적인 성격이며 건강한 라이프스타일을 추구합니다. 한국어와 한국 문화에 관심이 많으며 책임감 있고 성실한 파트너를 찾고 있습니다.',
      imageUrl: 'https://images.unsplash.com/photo-1611042553365-9b101441c135?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=928&q=80',
    },
    {
      id: 4,
      name: '부이 민 안',
      age: 25,
      location: '호치민',
      occupation: '디자이너',
      education: '대학교 졸업',
      height: 160,
      interests: ['그림 그리기', '패션', '사진 촬영'],
      description: '호치민에서 그래픽 디자이너로 일하고 있습니다. 창의적인 일을 좋아하며 새로운 것을 배우는 것을 즐깁니다. 가족을 소중히 여기며 서로 존중하고 이해하는 관계를 원합니다.',
      imageUrl: 'https://images.unsplash.com/photo-1601288496920-b6154fe3626a?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=928&q=80',
    },
    {
      id: 5,
      name: '레 티 마이',
      age: 27,
      location: '하노이',
      occupation: '마케팅 전문가',
      education: '대학교 졸업',
      height: 163,
      interests: ['요리', '댄스', '외국어 공부'],
      description: '하노이에서 마케팅 전문가로 일하고 있습니다. 활발하고 사교적인 성격이며 한국어를 꾸준히 공부하고 있습니다. 서로 배려하고 함께 성장할 수 있는 파트너를 찾고 있습니다.',
      imageUrl: 'https://images.unsplash.com/photo-1592124549776-a7f0cc973b24?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=928&q=80',
    },
    {
      id: 6,
      name: '응웬 티 탄',
      age: 23,
      location: '다낭',
      occupation: '학생',
      education: '대학교 재학 중',
      height: 157,
      interests: ['음악 감상', '여행', '쇼핑'],
      description: '다낭에서 경영학을 공부하고 있는 대학생입니다. 밝고 명랑한 성격이며 한국 문화와 K-Pop을 좋아합니다. 서로 의지하고 함께 행복한 가정을 이루고 싶습니다.',
      imageUrl: 'https://images.unsplash.com/photo-1602752250015-52934c497ed3?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=928&q=80',
    },
    {
      id: 7,
      name: '팜 티 투이',
      age: 26,
      location: '호치민',
      occupation: '요리사',
      education: '요리학교 졸업',
      height: 159,
      interests: ['요리', '베이킹', '요가'],
      description: '호치민의 유명 레스토랑에서 요리사로 일하고 있습니다. 음식을 통해 사랑을 표현하는 것을 좋아하며, 한국 요리에도 관심이 많습니다. 따뜻하고 이해심 많은 가정을 꾸리고 싶습니다.',
      imageUrl: 'https://images.unsplash.com/photo-1589571894960-20bbe2828d0a?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=928&q=80',
    },
    {
      id: 8,
      name: '트란 티 하',
      age: 29,
      location: '하노이',
      occupation: '은행원',
      education: '경영학 학사',
      height: 164,
      interests: ['독서', '재테크', '클래식 음악'],
      description: '하노이에서 은행원으로 일하고 있습니다. 책임감이 강하고 꼼꼼한 성격입니다. 안정적인 가정을 꾸리고 싶으며, 한국 문화와 발전된 사회에 깊은 관심이 있습니다.',
      imageUrl: 'https://images.unsplash.com/photo-1558898479-33c0057a5d12?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=928&q=80',
    },
    {
      id: 9,
      name: '응웬 티 미',
      age: 25,
      location: '다낭',
      occupation: '여행 가이드',
      education: '관광학 학사',
      height: 161,
      interests: ['여행', '사진', '언어 공부'],
      description: '다낭에서 여행 가이드로 일하고 있습니다. 활발하고 친화력이 좋은 성격입니다. 한국어를 유창하게 구사하며, 다양한 문화를 존중하고 새로운 경험을 좋아합니다.',
      imageUrl: 'https://images.unsplash.com/photo-1615212814093-f56085658024?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=928&q=80',
    },
    {
      id: 10,
      name: '팜 티 화',
      age: 27,
      location: '호치민',
      occupation: '피아니스트',
      education: '음악대학 졸업',
      height: 162,
      interests: ['피아노', '클래식 음악', '미술 감상'],
      description: '호치민에서 피아노 강사로 일하고 있습니다. 예술을 사랑하고 섬세한 감성을 가졌습니다. 한국의 발전된 문화예술에 깊은 관심이 있으며, 음악으로 마음을 나눌 수 있는 파트너를 찾고 있습니다.',
      imageUrl: 'https://images.unsplash.com/photo-1513673054901-79a0d30e1986?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=928&q=80',
    },
    {
      id: 11,
      name: '부이 티 란',
      age: 24,
      location: '하노이',
      occupation: '약사',
      education: '약학대학 졸업',
      height: 158,
      interests: ['건강 관리', '요리', '독서'],
      description: '하노이에서 약사로 일하고 있습니다. 건강과 가족을 중요시하며 책임감이 강합니다. 한국의 의료 시스템과 문화에 관심이 많으며, 서로 케어하고 존중하는 관계를 원합니다.',
      imageUrl: 'https://images.unsplash.com/photo-1596547605216-4a0e3ecc0959?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=928&q=80',
    },
    {
      id: 12,
      name: '르 투 짱',
      age: 26,
      location: '다낭',
      occupation: '호텔리어',
      education: '호텔경영학 학사',
      height: 162,
      interests: ['고객 서비스', '여행', '언어 공부'],
      description: '다낭의 5성급 호텔에서 근무하고 있습니다. 서비스 정신이 투철하고 다양한 사람들과 소통하는 것을 좋아합니다. 한국어를 공부 중이며, 서로 배려하는 진실된 관계를 찾고 있습니다.',
      imageUrl: 'https://images.unsplash.com/photo-1568822617270-2c1579f8dfe2?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=928&q=80',
    },
    {
      id: 13,
      name: '응웬 티 프엉',
      age: 28,
      location: '호치민',
      occupation: '프로그래머',
      education: '컴퓨터공학 석사',
      height: 160,
      interests: ['코딩', '독서', '보드게임'],
      description: 'IT 회사에서 프로그래머로 일하고 있습니다. 논리적이고 문제 해결 능력이 뛰어나며, 항상 새로운 기술을 배우는 것을 즐깁니다. 한국의 발전된 IT 산업과 문화에 관심이 많습니다.',
      imageUrl: 'https://images.unsplash.com/photo-1581403341630-a6e0b9d2d257?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=928&q=80',
    },
    {
      id: 14,
      name: '팜 티 응옥',
      age: 25,
      location: '하노이',
      occupation: '초등학교 교사',
      education: '교육학 학사',
      height: 159,
      interests: ['독서', '그림 그리기', '자원봉사'],
      description: '하노이에서 초등학교 교사로 일하고 있습니다. 아이들을 사랑하고 교육에 열정이 있습니다. 한국의 교육 시스템에 관심이 많으며, 함께 성장하고 발전할 수 있는 파트너를 찾고 있습니다.',
      imageUrl: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=928&q=80',
    },
    {
      id: 15,
      name: '트란 티 푸',
      age: 26,
      location: '다낭',
      occupation: '간호사',
      education: '간호학 학사',
      height: 163,
      interests: ['의료 봉사', '요가', '요리'],
      description: '다낭 종합병원에서 간호사로 일하고 있습니다. 따뜻한 마음과 헌신적인 성격을 가졌습니다. 환자를 돌보는 일에 보람을 느끼며, 가족을 소중히 여기는 한국 문화에 깊은 관심이 있습니다.',
      imageUrl: 'https://images.unsplash.com/photo-1606902965551-dce093cda6e7?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=928&q=80',
    },
    {
      id: 16,
      name: '응웬 티 아인',
      age: 27,
      location: '호치민',
      occupation: '통역사',
      education: '외국어대학 졸업',
      height: 161,
      interests: ['언어 공부', '여행', '영화 감상'],
      description: '호치민에서 한국어 통역사로 일하고 있습니다. 한국어와 영어를 유창하게 구사하며, 다양한 문화에 대한 이해도가 높습니다. 한국 생활에 빠르게 적응할 수 있으며, 소통이 원활한 관계를 원합니다.',
      imageUrl: 'https://images.unsplash.com/photo-1602751584552-8ba73aad10e1?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=928&q=80',
    },
    {
      id: 17,
      name: '트란 티 쑤안',
      age: 24,
      location: '하노이',
      occupation: '대학생',
      education: '경영학 전공',
      height: 157,
      interests: ['경제', '독서', '댄스'],
      description: '하노이 대학교에서 경영학을 전공하고 있습니다. 성실하고, 목표 지향적인 성격입니다. 한국 문화와 K-드라마를 좋아하며, 함께 미래를 그려나갈 수 있는 파트너를 찾고 있습니다.',
      imageUrl: 'https://images.unsplash.com/photo-1611432579699-484f7990b127?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=928&q=80',
    },
    {
      id: 18,
      name: '팜 티 응아',
      age: 26,
      location: '다낭',
      occupation: '카페 매니저',
      education: '호텔경영 전공',
      height: 160,
      interests: ['커피', '베이킹', '음악 감상'],
      description: '다낭에서 카페 매니저로 일하고 있습니다. 서비스 정신이 투철하고 사람들과 어울리는 것을 좋아합니다. 커피와 디저트에 대한 전문 지식이 있으며, 한국의 카페 문화에 관심이 많습니다.',
      imageUrl: 'https://images.unsplash.com/photo-1574701148212-8518049c7b2c?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=928&q=80',
    }
  ];
  
  // 필터링된 프로필 목록
  const filteredProfiles = profiles.filter(profile => {
    if (profile.age < ageRange.min || profile.age > ageRange.max) return false;
    if (locationFilter !== 'all' && profile.location !== locationFilter) return false;
    return true;
  });
  
  // 페이지네이션 계산
  const indexOfLastProfile = currentPage * profilesPerPage;
  const indexOfFirstProfile = indexOfLastProfile - profilesPerPage;
  const currentProfiles = filteredProfiles.slice(indexOfFirstProfile, indexOfLastProfile);
  const totalPages = Math.ceil(filteredProfiles.length / profilesPerPage);
  
  // 페이지 변경 핸들러
  const paginate = (pageNumber: number) => setCurrentPage(pageNumber);
  
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      
      {/* 배너 섹션 */}
      <section className="relative py-12 md:py-16">
        <div className="absolute inset-0 z-0">
          <img 
            src="https://images.unsplash.com/photo-1523731407965-2430cd12f5e4?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1770&q=80" 
            alt="베트남 결혼식" 
            className="w-full h-full object-cover brightness-50"
          />
        </div>
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-3xl md:text-4xl font-bold text-white mb-4">
              베트남 신부 매칭 서비스
            </h1>
            <p className="text-xl text-white opacity-90">
              철저한 검증과 맞춤형 매칭으로 여러분에게 딱 맞는 인연을 찾아드립니다.
            </p>
          </div>
        </div>
      </section>
      
      {/* 검색 및 필터 섹션 */}
      <section className="bg-white py-8 shadow-sm">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-5xl mx-auto">
            <div className="flex flex-col md:flex-row items-center justify-between gap-4">
              <div className="w-full md:w-1/3">
                <label className="block text-sm font-medium text-gray-700 mb-1">나이</label>
                <div className="flex items-center space-x-2">
                  <input 
                    type="number" 
                    className="block w-full rounded-md border-gray-300 shadow-sm focus:border-primary-500 focus:ring-primary-500 sm:text-sm" 
                    value={ageRange.min}
                    onChange={(e) => setAgeRange({...ageRange, min: parseInt(e.target.value) || 18})}
                    min="18"
                    max="50"
                  />
                  <span>~</span>
                  <input 
                    type="number" 
                    className="block w-full rounded-md border-gray-300 shadow-sm focus:border-primary-500 focus:ring-primary-500 sm:text-sm" 
                    value={ageRange.max}
                    onChange={(e) => setAgeRange({...ageRange, max: parseInt(e.target.value) || 50})}
                    min="18"
                    max="50"
                  />
                </div>
              </div>
              
              <div className="w-full md:w-1/3">
                <label className="block text-sm font-medium text-gray-700 mb-1">지역</label>
                <select 
                  className="block w-full rounded-md border-gray-300 shadow-sm focus:border-primary-500 focus:ring-primary-500 sm:text-sm"
                  value={locationFilter}
                  onChange={(e) => setLocationFilter(e.target.value)}
                >
                  <option value="all">전체 지역</option>
                  <option value="호치민">호치민</option>
                  <option value="하노이">하노이</option>
                  <option value="다낭">다낭</option>
                </select>
              </div>
              
              <div className="w-full md:w-1/3">
                <button 
                  className="w-full md:mt-7 bg-primary-600 text-white hover:bg-primary-700 py-2 px-4 rounded-md font-medium"
                >
                  검색하기
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      {/* 프로필 섹션 */}
      <section className="py-12 md:py-16 bg-gray-50">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-5xl mx-auto">
            <h2 className="text-2xl font-bold text-gray-900 mb-8">
              검색 결과: {filteredProfiles.length}명의 인연
            </h2>
            
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {currentProfiles.map(profile => (
                <div key={profile.id} className="bg-white rounded-lg shadow-sm overflow-hidden">
                  <div className="h-64 overflow-hidden">
                    <img 
                      src={profile.imageUrl} 
                      alt={profile.name} 
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div className="p-6">
                    <h3 className="text-xl font-semibold text-gray-900 mb-1">
                      {profile.name} ({profile.age})
                    </h3>
                    <p className="text-gray-500 mb-3">
                      {profile.location} · {profile.occupation}
                    </p>
                    <div className="flex flex-wrap gap-2 mb-4">
                      {profile.interests.map((interest, index) => (
                        <span 
                          key={index} 
                          className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-primary-100 text-primary-800"
                        >
                          {interest}
                        </span>
                      ))}
                    </div>
                    <p className="text-gray-600 text-sm mb-4 line-clamp-3">
                      {profile.description}
                    </p>
                    <div className="mt-2">
                      <button className="w-full bg-primary-600 text-white hover:bg-primary-700 py-2 px-4 rounded-md font-medium">
                        상세 프로필 보기
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
            
            {filteredProfiles.length === 0 && (
              <div className="text-center py-12">
                <p className="text-gray-500 text-lg">
                  검색 조건에 맞는 프로필이 없습니다.
                </p>
                <p className="text-gray-500">
                  다른 검색 조건을 시도해보세요.
                </p>
              </div>
            )}
            
            {/* 페이지네이션 */}
            {filteredProfiles.length > 0 && (
              <div className="mt-12 flex justify-center">
                <nav className="inline-flex rounded-md shadow">
                  <button
                    onClick={() => currentPage > 1 && paginate(currentPage - 1)}
                    disabled={currentPage === 1}
                    className="px-4 py-2 rounded-l-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    이전
                  </button>
                  
                  {/* 페이지 번호 버튼 */}
                  {Array.from({ length: totalPages }).map((_, index) => (
                    <button
                      key={index}
                      onClick={() => paginate(index + 1)}
                      className={`px-4 py-2 border-t border-b border-gray-300 text-sm font-medium
                        ${currentPage === index + 1
                          ? 'bg-primary-600 text-white border-primary-600'
                          : 'bg-white text-gray-700 hover:bg-gray-50'
                        }`
                      }
                    >
                      {index + 1}
                    </button>
                  ))}
                  
                  <button
                    onClick={() => currentPage < totalPages && paginate(currentPage + 1)}
                    disabled={currentPage === totalPages}
                    className="px-4 py-2 rounded-r-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    다음
                  </button>
                </nav>
              </div>
            )}
          </div>
        </div>
      </section>
      
      {/* 안내 섹션 */}
      <section className="py-12 md:py-16 bg-white">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-5xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">
                매칭 서비스 안내
              </h2>
              <p className="text-lg text-gray-600">
                저희 베트남 국제결혼 매칭 서비스는 다음과 같은 절차로 진행됩니다.
              </p>
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <div className="bg-gray-50 rounded-lg p-6 text-center">
                <div className="w-12 h-12 bg-primary-100 text-primary-600 rounded-full flex items-center justify-center mx-auto mb-4">
                  <span className="text-xl font-bold">1</span>
                </div>
                <h3 className="text-lg font-semibold text-gray-900 mb-2">
                  상담 신청
                </h3>
                <p className="text-gray-600">
                  전화 또는 온라인으로 무료 상담을 신청하세요. 전문 컨설턴트가 여러분의 니즈와 선호도를 파악합니다.
                </p>
              </div>
              
              <div className="bg-gray-50 rounded-lg p-6 text-center">
                <div className="w-12 h-12 bg-primary-100 text-primary-600 rounded-full flex items-center justify-center mx-auto mb-4">
                  <span className="text-xl font-bold">2</span>
                </div>
                <h3 className="text-lg font-semibold text-gray-900 mb-2">
                  프로필 매칭
                </h3>
                <p className="text-gray-600">
                  여러분의 조건과 선호도에 맞는 베트남 신부 후보자를 소개해드립니다. 화상 통화를 통해 직접 대화할 기회를 제공합니다.
                </p>
              </div>
              
              <div className="bg-gray-50 rounded-lg p-6 text-center">
                <div className="w-12 h-12 bg-primary-100 text-primary-600 rounded-full flex items-center justify-center mx-auto mb-4">
                  <span className="text-xl font-bold">3</span>
                </div>
                <h3 className="text-lg font-semibold text-gray-900 mb-2">
                  현지 만남 및 결혼
                </h3>
                <p className="text-gray-600">
                  마음에 드는 상대를 만나면 베트남 현지 방문을 도와드립니다. 모든 법적 절차와 결혼 준비를 원스톱으로 지원합니다.
                </p>
              </div>
            </div>
            
            <div className="mt-12 text-center">
              <Link
                to="/contact"
                className="inline-block bg-primary-600 text-white hover:bg-primary-700 py-3 px-8 rounded-md font-medium"
              >
                무료 상담 신청하기
              </Link>
            </div>
          </div>
        </div>
      </section>
      
      <Footer />
    </div>
  );
}

export default MatchPage; 